import React, { useState, useEffect, useRef } from "react";
import { Popover } from './Popover/Popover';
export function Popper({ children, target, align, hideOnClick = true }) {
    const [position, setPosition] = useState();
    const contentRef = useRef(null);
    useEffect(() => {
        const click = (e) => {
            e.preventDefault();
            setPosition({ x: 0, y: 0 });
            setTimeout(() => {
                if (!contentRef.current) {
                    return;
                }
                const targetRect = target.getBoundingClientRect();
                const contentRect = contentRef.current.getBoundingClientRect();
                if (align == 'bottom-end') {
                    setPosition({
                        x: targetRect.right - contentRect.width,
                        y: targetRect.bottom
                    });
                }
            }, 100);
        };
        target.addEventListener('mousedown', click);
        return () => target.removeEventListener('mousedown', click);
    }, [target]);
    return React.createElement(Popover, { position: position, hideOnClick: hideOnClick, ref: contentRef }, children);
}
